import { create } from 'zustand';
import { TOUR_LS_KEY } from 'src/constants'

interface TourState {
  isTourGuideOpen: boolean;
  isTourStepOpen: boolean;
  currentStep: number;
  totalSteps: number;
  
  // Actions
  openTourGuide: () => void;
  closeTourGuide: () => void;
  startTour: () => void;
  nextStep: () => void;
  previousStep: () => void;
  closeTour: () => void;
  setDontShowAgain: () => void;
  checkShouldShowTour: () => boolean;
}

export const useTourStore = create<TourState>((set, get) => ({
  isTourGuideOpen: false,
  isTourStepOpen: false,
  currentStep: 1,
  totalSteps: 6,

  checkShouldShowTour: () => {
    // Check if user has disabled the tour
    const hideTour = typeof window !== 'undefined' && localStorage.getItem(TOUR_LS_KEY) === '1';
    if (hideTour) return false;

    // Check screen width (should be > 1400px)
    if (typeof window !== 'undefined' && window.innerWidth <= 1400) {
      return false;
    }

    return true;
  },

  openTourGuide: () => {
    if (get().checkShouldShowTour()) {
      set({ isTourGuideOpen: true, currentStep: 1 });
    }
  },

  closeTourGuide: () => {
    set({ isTourGuideOpen: false });
  },

  startTour: () => {
    set({ isTourStepOpen: true, currentStep: 2 }); // Start from step 2
  },

  nextStep: () => {
    const { currentStep, totalSteps } = get();
    if (currentStep < totalSteps) {
      set({ currentStep: currentStep + 1 });
    } else {
      set({ isTourStepOpen: false, isTourGuideOpen: false });
    }
  },

  previousStep: () => {
    const { currentStep } = get();
    set({ currentStep: currentStep - 1 });
  },

  closeTour: () => {
    set({ isTourStepOpen: false, isTourGuideOpen: false });
  },

  setDontShowAgain: () => {
    try {
      localStorage.setItem(TOUR_LS_KEY, '1');
    } catch (error) {
      console.error('Failed to save dont show again preference:', error);
    }
    set({ isTourGuideOpen: false });
  },
}));
